function bindFaqSmg(root) {
  var scope = root || document;

  scope.querySelectorAll('[data-faq-smg]').forEach(function (faqRoot) {
    faqRoot.querySelectorAll('.faq-item').forEach(function (item) {
      var summary = item.querySelector('summary');
      var content = item.querySelector('p');

      if (!summary || !content) return;

      // Evitar registrar múltiples listeners al mismo summary
      if (summary.dataset.faqSmgBound === 'true') return;
      summary.dataset.faqSmgBound = 'true';

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        if (item.classList.contains('is-open')) {
          // Si ya está abierto, solo lo cerramos
          closeItem(item, content);
        } else {
          // Acordeón: cerrar cualquier otro item abierto dentro del mismo bloque FAQ
          faqRoot.querySelectorAll('.faq-item.is-open, .faq-item[open]').forEach(function (otherItem) {
            if (otherItem === item) return;

            var otherContent = otherItem.querySelector('p');
            if (!otherContent) return;

            closeItem(otherItem, otherContent);
          });

          // Abrir el item actual
          openItem(item, content);
        }
      });
    });
  });
}

// Ejecutar inmediatamente según el estado del documento (Shopify puede cargar el script después del DOMContentLoaded)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    bindFaqSmg(document);
  });
} else {
  bindFaqSmg(document);
}

// Soporte para secciones dinámicas de Shopify (cuando se añade/recarga la sección en el editor)
document.addEventListener('shopify:section:load', function (event) {
  bindFaqSmg(event.target);
});

function openItem(item, content) {
  item.classList.add('is-open');
  item.setAttribute('open', '');

  content.style.height = '0px';
  var height = content.scrollHeight;

  requestAnimationFrame(function () {
    content.style.transition = 'height 0.45s ease';
    content.style.willChange = 'height';
    content.style.height = height + 'px';
  });

  content.addEventListener(
    'transitionend',
    function () {
      content.style.height = 'auto';
      content.style.willChange = '';
    },
    { once: true }
  );
}

function closeItem(item, content) {
  var height = content.scrollHeight;

  content.style.height = height + 'px';

  requestAnimationFrame(function () {
    content.style.transition = 'height 0.45s ease';
    content.style.willChange = 'height';
    content.style.height = '0px';
  });

  content.addEventListener(
    'transitionend',
    function () {
      item.classList.remove('is-open');
      item.removeAttribute('open');
      content.style.height = '';
      content.style.transition = '';
      content.style.willChange = '';
    },
    { once: true }
  );
}
